export type Language = 'en' | 'es';

/**
 * Also read by the inline preload script in `index.html`, which starts fetching the
 * language file before the bundle boots. Keep the two in sync.
 */
export const LANGUAGE_STORAGE_KEY = 'ld-preferred-language';

export function getStoredLanguage(): Language {
  if (typeof localStorage === 'undefined') {
    return 'en';
  }
  return localStorage.getItem(LANGUAGE_STORAGE_KEY) === 'es' ? 'es' : 'en';
}
